import React, { useEffect } from 'react';
import { ApplicationView } from '@aha-app/mvc';
import { type MessageProps } from './MessageContent';
import ReactContent from './ReactContent';
import IframeLoadingImage from './IframeLoadingImage';

const MultiFileReactContent = ({ body, toolCallData }: MessageProps) => {
  const [fileContent, setFileContent] = React.useState<Record<string, string>>(
    {}
  );

  let parsedToolCallData: {
    modified_file?: string;
    has_app_file?: boolean;
  } | null = null;

  if (toolCallData) {
    try {
      parsedToolCallData = JSON.parse(toolCallData) as {
        modified_file?: string;
        has_app_file?: boolean;
      };
    } catch (e) {
      console.error('Failed to parse toolCallData:', e);
    }
  }

  useEffect(() => {
    // Parse body as JSON containing all files
    try {
      const files = JSON.parse(body) as Record<string, string>;
      setFileContent(files);
    } catch (e) {
      // If parsing fails, assume single file content occurs during streaming
      setFileContent({ 'App.tsx': body });
    }
  }, [body]);

  if (Object.keys(fileContent).length === 0) {
    return (
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <IframeLoadingImage />
      </div>
    );
  } else {
    if (
      parsedToolCallData?.modified_file &&
      !parsedToolCallData?.has_app_file &&
      parsedToolCallData.modified_file !== 'App.tsx' &&
      fileContent[parsedToolCallData.modified_file]
    ) {
      return (
        <ReactContent
          files={{ 'App.tsx': fileContent[parsedToolCallData.modified_file] }}
          contentType={'application/vnd.aha.react'}
          componentFileName={parsedToolCallData.modified_file}
        />
      );
    } else {
      return (
        <ReactContent
          files={fileContent}
          contentType={'application/vnd.aha.react'}
        />
      );
    }
  }
};

export default ApplicationView(MultiFileReactContent);
